<template>
    <div 
        class="card" 
        :class="item.url_midia_colaboracao && !isFullScreen ? 'mb-14'
                : !isFullScreen ? 'mb-14' : ''"
        :style= "cardStyle"
        :key="item.id_colaboracao"
    >
        <div class="wrapper">
            <div class="purple-wrapper"></div>
            <div class="blue-wrapper"></div>
            <div class="orange-wrapper"></div>
            <div class="card-content d-flex flex-column">
                <header class="d-flex align-center w-100">
                    <v-avatar :size="isFullScreen ? '92' : '42'" class="ml-4 mt-1">
                        <v-img :src="item.url_avatar_colaborador" alt="Foto perfil twitter" cover />
                    </v-avatar>
                <div class="flex flex-row ml-3 pa-0 mt-n5">
                    <div class="d-flex align-center">
                        <h6 
                            class="font-weight-black black--text text-lowercase "
                            :class="isFullScreen ? 'text-h4' : 'text-subtitle-1'"
                        >
                            {{ item.dsc_nome_colaborador }}
                        </h6>
                        <v-icon v-if="item.flg_colaborador_verificado === true" size="large" color="#009DF7" class="ml-1">
                            mdi-check-decagram
                        </v-icon>
                        <span 
                            class="ml-1 font-weight-medium gray--text"
                            :class="isFullScreen ? 'text-h4' : 'text-subtitle-2'"
                            >{{ item.dsc_colaborador_user }}
                        </span>
                    </div>
                </div>
                    <TwitterSvg 
                        class="mr-2 mt-n2" 
                        style="width: 18px; height: 18px;"
                    />
                </header>
                <section class="d-flex flex-wrap flex-grow-1 align-center justify-center mt-n4 mx-1">
                    <div
                        v-html="colabText"
                        class="px-6 ml-10 align-self-center black--text font-weight-medium"
                        :style="isFullScreen ? {'lineHeight': lineHeightFullScreen, 'fontSize': bodyTextSizeFullSreen} : 
                        {'lineHeight': lineHeight, 'fontSize': bodyTextSize}"
                    >
                    </div>
                </section>
                <footer style="width: 100%;" class="d-flex align-self-end justify-end">
                    <span 
                        class="mr-3 mb-3 align-self-end black--text font-weight-medium"
                        :class="isFullScreen ? 'text-h5' : 'text-caption'"
                    >
                    {{ item.dat_colaboracao | twitterData }}
                    </span>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import TwitterSvg from "@/assets/twitter.svg";
import { monthNumberToNameObject } from "@/utils/dateUtils";
export default {
    props: {
        item: Object,
        posicaoCard: String,
        isFullScreen: Boolean,
    },
    filters: {
        twitterData(data_string) {
            const [ day, month, year ] = new Date(data_string).toLocaleDateString().split("/")
            const [ hour, minutes, ] = new Date(data_string).toLocaleTimeString().split(":")
            const period = hour >= 12 && hour <= 23 ? 'PM' : 'AM'
            const formated_hour = period === 'PM' && hour > 12 ? Number(hour) - 12 : hour
            const date = `${formated_hour}:${minutes} ${period} · ${day} de ${monthNumberToNameObject[month].slice(0, 3).toLowerCase()} de ${year}`
            return date
        },
    },
    computed: {
        renderMode() {
            if(this.isFullScreen) {
                return 'fullscreen'
            }
            return 'text'
        },
        bodyTextSize() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            const size = numChars > 0 & numChars <= 40 ? '1.4rem'
                         : numChars > 40 && numChars <= 80 ? '1.2rem'
                         : numChars > 80 && numChars <= 120 ? '1rem'
                         : numChars > 120 && numChars <= 160 ? '1rem'
                         : numChars > 160 && numChars <= 200 ? '.9rem'
                         : numChars > 200 && numChars <= 240 ? '.8rem'
                         : numChars > 240 && numChars <= 280 ? '.75rem'
                         : '1.5rem'
            return size;
        },
        lineHeight() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            const lineHeight = numChars > 0 & numChars <= 40 ? '1.4rem'
                         : numChars > 40 && numChars <= 80 ? '1.2rem'
                         : numChars > 80 && numChars <= 120 ? '1.1rem'
                         : numChars > 120 && numChars <= 160 ? '1rem'
                         : numChars > 160 && numChars <= 200 ? '.95rem'
                         : numChars > 200 && numChars <= 240 ? '.9rem'
                         : numChars > 240 && numChars <= 280 ? '.8rem'
                         : '1.5rem'

            return lineHeight
        },
        bodyTextSizeFullSreen() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            const size = numChars > 0 & numChars <= 40 ? '3.8rem'
                : numChars > 40 && numChars <= 80 ? '3.5rem'
                    : numChars > 80 && numChars <= 120 ? '3.2rem'
                        : numChars > 120 && numChars <= 160 ? '2.8rem'
                            : numChars > 160 && numChars <= 200 ? '2.6rem'
                                : numChars > 200 && numChars <= 240 ? '2.5rem'
                                    : numChars > 240 && numChars <= 280 ? '2.3rem'
                                        : '1.5rem'
            return size;
        },
        lineHeightFullScreen() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            const lineHeight = numChars > 0 & numChars <= 40 ? '3.8rem'
                : numChars > 40 && numChars <= 80 ? '3.5rem'
                    : numChars > 80 && numChars <= 120 ? '3.2rem'
                        : numChars > 120 && numChars <= 160 ? '2.8rem'
                            : numChars > 160 && numChars <= 200 ? '2.6rem'
                                : numChars > 200 && numChars <= 240 ? '2.5rem'
                                    : numChars > 240 && numChars <= 280 ? '2.3rem'
                                        : '1.5rem'

            return lineHeight
        },
        screenDimensions() {
            return {
                width: this.$vuetify.breakpoint.width,
                height: this.$vuetify.breakpoint.height
            }
        },
        colabText() {
            return this.formatText(this.item.dsc_texto_colaboracao);
        },
        cardStyle() {
            if(this.isFullScreen) {
                const sizes = `width: 960px !important; height: 380px !important`;
                const align = `justify-self: center; align-self: center;`
                const fullscreenStyle = sizes.split(";").concat(align.split(";"));
                return fullscreenStyle.filter(item => item).join(";")
            }

            const position = this.posicaoCard === 'esquerda' && !this.item.url_midia_colaboracao ? 
                                'margin-left: 100px; justify-self: flex-start'
                             : this.posicaoCard === 'centro' ? 'justify-self: center'
                             : this.posicaoCard === 'direita' && !this.item.url_midia_colaboracao ? 
                                'margin-right: 40px; justify-self: flex-end'
                             : this.posicaoCard === 'direita' && this.item.url_midia_colaboracao ? 
                                'margin-right: 60px; justify-self: flex-start'
                             : this.posicaoCard === 'esquerda' && this.item.url_midia_colaboracao ? 
                                'margin-left: 120px; justify-self: flex-start'
                            : ''
            const array = position.split(";")
            return array.filter(item => item).join(";")
        },
    },
    components: {
        TwitterSvg
    },
    data() {
        return {
        }
    },
    methods: {
        formatText(text) {
            const words = text.replaceAll("\n", " ").split(" ");
            const hashtagRe = new RegExp("(?<!\\S)#\\S+|\\S+#(?!\\S)")
            const twitterUserRe = new RegExp("^@[a-zA-Z-à-ú0-9_]{0,15}.$");
            const newWords = words.map((word) => {
                let result = word
                const wordHasHashtag = hashtagRe.test(word)
                const wordHasUser = twitterUserRe.test(word)
                if(wordHasHashtag || wordHasUser) {
                    const ponctuationRe = new RegExp("\\p{P}+$", "umg")
                    if(ponctuationRe.test(word)) {
                        result = `<span class='userOrHashtag'>${word.slice(0, word.length - 1)}</span>${word.slice(-1)}`;
                    } else {
                        result = `<span class='userOrHashtag'>${word}</span>`
                    }
                }
                return result;
            })
            return newWords.join(" ").trim()
        },
    },
}
</script>

<style lang="scss" scoped>
.card {
    // width: 630px;
    // height: 60px;
    // border-radius: 4px;
}

.wrapper {
    position: relative;
    width: 520px;
    height: 140px;
}

.purple-wrapper {
    width: 520px;
    height: 110px;
    border-left: 3px solid #CA00CE;
    border-top: 2px solid #CA00CE;
    position: absolute;
    transform: skew(2deg, -1deg);
    padding: 8px;
}
.card-content {
    position: absolute;
    z-index: 10;
/*   border: 1px solid black; */
    width: 92%;
    height: 70%;
    background-color: #fff;
    top: 20px;
    left: 15px;
    transform: rotate(0deg);
}

.blue-wrapper {
    position: relative;
    top: 10px;
    width: 100%;
    height: 100%;
    background-color: #008ACE;
    /*   transform: skew(2deg, 2deg); */
    clip-path: polygon(2% 0, 98% 0, 96% 92%, 2% 88%);
}
.orange-wrapper {
    position: absolute;
    top: 10px;
    width: 100%;
    height: 100%;
    background-color: #FF8A00;
    clip-path: polygon(1% 15%, 97% 0, 95% 87%, 3% 81%);
}

</style>
